import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommentsModule } from '@helios/comments'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import { NfFormsModule } from '@northfork/ng-basics'
import { AggregateAccountListGridComponent } from './aggregate-account-list-grid/aggregate-account-list-grid.component'
import { ExternalAccountsPanelComponent } from './external-accounts-panel.component'
import { SubAccountListGridComponent } from './sub-account-list-grid/sub-account-list-grid.component'

@NgModule({
  imports: [
    CommonModule,
    GridWrapperModule,
    NfFormsModule,
    FormsModule,
    TableLayoutModule,
    GenericComponentsModule,
    ReactiveFormsModule,
    ResizeHandleModule,
    CommentsModule,
  ],
  declarations: [
    SubAccountListGridComponent,
    AggregateAccountListGridComponent,
    ExternalAccountsPanelComponent,
  ],
  exports: [
    SubAccountListGridComponent,
    AggregateAccountListGridComponent,
    ExternalAccountsPanelComponent,
  ],
})
export class ExternalAccountsModule {}

export { ExternalAccountsPanelComponent }
